<template>
    <v-dialog v-model="isOpen" persistent width="500">
        <v-card>
            <v-toolbar dense dark flat color="primary">
                <v-toolbar-title>{{ title }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="mt-3">
                <p class="text-base">{{ message }}</p>
            </v-card-text>
            <v-card-actions class="d-md-flex justify-end">
                <v-btn color="secondary" text class="mr-2" @click="cancel">
                    <span>Cancelar</span>
                </v-btn>
                <v-btn color="primary" @click="confirm">
                    <span>Confirmar</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ConfirmDialog",
    data() {
        return {
            isOpen: false,
            title: "",
            message: "",
            pendingAction: null
        };
    },
    methods: {
        open(config) {
            this.title = config.title || "¿Estás seguro?";
            this.message = config.message || "Esta acción no se puede deshacer";
            this.pendingAction = config.action || null;
            this.isOpen = true;
        },

        confirm() {
            if (this.pendingAction) {
                this.pendingAction();
            }
            this.isOpen = false;
        },

        cancel() {
            this.isOpen = false;
            this.pendingAction = null;
        }
    }
};
</script>

<style scoped>
.text-base {
    font-size: 16px;
    line-height: 1.5;
}
</style>